import strData from "../datafiles/stringmanagement_data.json";
import enStrData from "../datafiles/stringmanagement_en_data.json";
import { getLocaleInfo } from "../Config";
import { Locale } from "../Api/Types";
import { isEndWithConsonant } from "./ApiCommonTS";

interface IString {
  target: string;
  value: any;
}

// 스트링 key => 스트링 대치
export const GetStringByKey = (key: number) => {
  let strfile = null;
  let str = "";

  switch (getLocaleInfo()) {
    case Locale.kokr:
      strfile = strData;
      break;
    case Locale.koen:
      strfile = enStrData;
      break;
    default:
      break;
  }

  if (strfile) {
    const findValue = strfile?.find((data) => data.STRING_ID === key);

    if (findValue) {
      str = findValue?.STRING ?? "";
    }
  }

  return str;
};

// 스트링 key => 스트링 대치 with 변수
export const GetStringByKeyValues = (key: number, values: IString[]) => {
  const originMsg = GetStringByKey(key);
  let msg = originMsg;

  if (msg && values?.length > 0) {
    for (let i = 0; i < values.length; i++) {
      const target = values[i].target;
      const value = values[i].value;

      msg = msg.replace(target, `${value}`);

      const hasConsonant = isEndWithConsonant(`${value}`);

      msg = msg?.replace(/을\/를|은\/는/g, (vl) => {
        switch (vl) {
          case "을/를":
            return hasConsonant ? "을" : "를";

          case "은/는":
            return hasConsonant ? "은" : "는";

          default:
            return vl;
        }
      });
    }
  }

  return msg;
};
